import { playDomUiClick } from '../audio/uiClick';

const ACCESS_STORAGE_KEY = 'glass-shot:access-granted';
const ENCODED_PASSPHRASE = 'bnlh';

function hasStoredAccess(): boolean {
  try {
    return window.localStorage.getItem(ACCESS_STORAGE_KEY) !== null;
  } catch {
    return false;
  }
}

function storeAccess(): void {
  try {
    window.localStorage.setItem(ACCESS_STORAGE_KEY, '1');
  } catch {
    // Storage may be unavailable in restricted browser modes. Keep this session unlocked.
  }
}

export function requirePassphraseAccess(): Promise<void> {
  if (hasStoredAccess()) return Promise.resolve();

  return new Promise((resolve) => {
    const dialog = document.createElement('dialog');
    dialog.className = 'passphrase-gate';
    dialog.setAttribute('aria-labelledby', 'passphrase-gate-title');

    const form = document.createElement('form');
    form.className = 'passphrase-gate__panel';

    const brand = document.createElement('span');
    brand.className = 'passphrase-gate__brand';
    brand.textContent = 'GLASS SHOT';

    const title = document.createElement('h1');
    title.id = 'passphrase-gate-title';
    title.className = 'passphrase-gate__title';
    title.textContent = 'あいことば';

    const label = document.createElement('label');
    label.className = 'passphrase-gate__label';
    label.htmlFor = 'passphrase';
    label.textContent = 'あいことばを入力';

    const input = document.createElement('input');
    input.id = 'passphrase';
    input.className = 'passphrase-gate__input';
    input.type = 'password';
    input.name = 'passphrase';
    input.autocomplete = 'off';
    input.spellcheck = false;
    input.required = true;
    input.setAttribute('aria-describedby', 'passphrase-error');

    const error = document.createElement('p');
    error.id = 'passphrase-error';
    error.className = 'passphrase-gate__error';
    error.setAttribute('aria-live', 'polite');

    const submit = document.createElement('button');
    submit.className = 'passphrase-gate__submit';
    submit.type = 'submit';
    submit.textContent = 'OK';

    label.append(input);
    form.append(brand, title, label, error, submit);
    dialog.append(form);
    document.body.append(dialog);

    dialog.addEventListener('cancel', (event) => event.preventDefault());
    input.addEventListener('input', () => {
      input.removeAttribute('aria-invalid');
      error.textContent = '';
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      playDomUiClick();

      if (input.value !== window.atob(ENCODED_PASSPHRASE)) {
        input.setAttribute('aria-invalid', 'true');
        error.textContent = 'あいことばが違います';
        form.classList.remove('passphrase-gate__panel--invalid');
        requestAnimationFrame(() => form.classList.add('passphrase-gate__panel--invalid'));
        input.select();
        return;
      }

      storeAccess();
      dialog.close();
      dialog.remove();
      resolve();
    });

    dialog.showModal();
    input.focus();
  });
}
